<div class="relative bg-white rounded-xl w-full max-w-2xl">
  <button class="absolute top-4 right-4 text-gray-10 hover:text-gray-12 transition-colors" (click)="close()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <div class="text-center mb-8">
    <h2 class="text-2xl font-semibold text-gray-12">Ajoutez des photos</h2>
    <p class="text-gray-11 mt-1">Aucun élément sélectionné</p>
  </div>

  <aura-photo-dropzone (filesSelected)="onFilesSelected($event)"></aura-photo-dropzone>

  <div class="mt-8 flex justify-between items-center border-t border-gray-4 pt-4">
    <button class="text-gray-12 font-medium hover:text-brand-9 transition-colors" (click)="close()">
      Terminé
    </button>

    <button class="bg-gray-3 text-gray-10 px-6 py-2 rounded-lg font-medium cursor-not-allowed" disabled>
      Importer
    </button>
  </div>
</div>
